module.exports = __webpack_public_path__ + "static/assets/f3cd3bde88a384bf6757c9f30508cdd6.svg";